<template>
  <v-dialog v-model="dialog" width="640">
    <line-up-form
      ref="form"
      :team-id="teamId"
      :edit="edit"
      @submit="submit"
      @cancel="cancel"
    />
  </v-dialog>
</template>

<script>
import LineUpForm from './LineUpForm'
export default {
  name: 'DialogTeamLineUp',
  components: { LineUpForm },
  props: {
    teamId: {
      type: String,
      required: true,
      default: '',
    },
    matchId: {
      type: String,
      required: false,
      default: '',
    },
    teamType: {
      type: String,
      required: false,
      default: 'home',
    },
    actions: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    edit: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      dialog: false,
      lineUp: {},
      loading: false,
    }
  },
  methods: {
    // ...mapActions({
    //   fetchLineUp: 'teams/fetchLineUp',
    //   addLineUp: 'teams/addLineUp',
    //   updateLineUp: 'teams/updateLineUp'
    // }),
    // init() {
    //   if (this.teamId && this.lineUpId) {
    //     this.loading = true
    //     let payload = { teamId: this.teamId, lineUpId: this.lineUpId }
    //     this.fetchLineUp(payload)
    //       .then(lineUp => this.nextTick(() => this.$ref.form.setLineUp(lineUp)))
    //       .finally(() => {
    //         this.loading = false
    //       })
    //   }
    // },
    open() {
      this.dialog = true
    },

    setLineUp(lineUp) {
      if (this.teamId && lineUp) {
        this.open()
        // this.nextTick(() => {
        //   this.loading = true
        //   const payload = { teamId: this.teamId, lineUpId: lineUpId }
        //   this.fetchLineUp(payload)
        //     .then(lineUp => {
        this.nextTick(
          () => this.$refs.form && this.$refs.form.setLineUp(lineUp)
        )
        // })
        // .finally(() => {
        //   this.loading = false
        // })
        // })
      }
    },
    submit(lineUp) {
      let { _id, ...payload } = lineUp

      if (this.matchId) {
        payload.matchId = this.matchId
        payload.teamType = this.teamType
      } else if (this.teamId) {
        payload.teamId = this.teamId
      } else return

      let promise
      if (_id) {
        promise =
          this.actions.updateLineUp &&
          this.actions.updateLineUp({ ...payload, lineUpId: _id })
      } else {
        promise = this.actions.addLineUp && this.actions.addLineUp(payload)
      }

      if (promise) {
        this.loading = true
        promise
          .then(() => this.cancel())

          .finally(() => {
            this.loading = false
          })
      }
    },

    clear() {
      this.nextTick(() => this.$refs.form && this.$refs.form.clear())
    },
    cancel() {
      this.clear()
      this.dialog = false
    },
  },
}
</script>
